import script from "./DesignationAddModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DesignationAddModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__